import { PaymentMethod } from 'modules/purchase/constants'
import { eventLogger } from 'services/eventLogger.service'
import { ScreenName } from 'root-constants'

export const logStartedPayPalPayment = ({
  productId,
  price,
  paymentMethod,
  currency,
  screenName,
  isTrialActive,
}: {
  productId: string
  price: number
  paymentMethod: PaymentMethod
  currency: string
  screenName: ScreenName
  isTrialActive?: boolean
}): void => {
  eventLogger.logPurchaseStarted({
    productId,
    priceDetails: {
      price,
      currency,
      trial: isTrialActive,
    },
    paymentMethod,
    screenName,
  })
}
